<template>
  <div class="verification-form-pep">
    <div class="verification-cdd-form__risk-fields app-key-value__list">
      <div class="verification-cdd-form__questions-list">
        <h2 class="verification-cdd-form__title">
          {{ "verification-form-pep.title" | globalize }}
        </h2>
        <h3 class="verification-cdd-form__title">
          {{ "verification-form-pep.subtitle" | globalize }}
        </h3>

        <div class="verification-cdd-form__question-wrp">
          <verification-form-question
            v-model="form.qus01"
            @input="former.setAttr('pep.qus01', form.qus01)"
            :question-message="
              'verification-form-pep.qus-01' | globalize"
            :error-message="getFieldErrorMessage('form.qus01')"
            :disabled="isDisabled"
          >
            <p>{{ 'verification-form-pep.lbl-pep-info' | globalize }}</p>
          </verification-form-question>
          <input-field
            v-if="CB_VALUES.yes === form.qus01"
            v-model="form.pepInfo"
            @input="former.setAttr('pep.pepInfo', form.pepInfo)"
            :error-message="getFieldErrorMessage('form.pepInfo')"
            :label="'verification-form-pep.lbl-qus-01' | globalize"
            :disabled="isDisabled"
          />
        </div>

        <div class="verification-cdd-form__question-wrp">
          <verification-form-question
            v-model="form.qus02"
            @input="former.setAttr('pep.qus02', form.qus02)"
            :question-message="
              'verification-form-pep.qus-02' | globalize"
            :error-message="getFieldErrorMessage('form.qus02')"
            :disabled="isDisabled"
          >
            <p>
              {{ 'verification-form-pep.lbl-country-risk' | globalize }}
            </p>
          </verification-form-question>
          <input-field
            v-if="CB_VALUES.yes === form.qus02"
            v-model="form.countryRisk"
            @input="former.setAttr('pep.countryRisk', form.countryRisk)"
            :error-message="getFieldErrorMessage('form.countryRisk')"
            :label="'verification-form-pep.lbl-qus-02' | globalize"
            :disabled="isDisabled"
          />
        </div>

        <a :href="watchlistReportLink">
          {{ 'verification-form-pep.lbl-link' | globalize }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import VerificationFormQuestion from './VerificationFormQuestion'

import { VerificationRecord } from '@/js/records/entities/verification.record'
import { VerificationCDDFormer } from '@/js/formers/VerificationCDDFormer'
import { VerificationBDDFormer } from '@/js/formers/VerificationBDDFormer'
import { required } from '@validators'

import FormMixin from '@/vue/mixins/form.mixin'

const CB_VALUES = {
  yes: 'Yes',
  no: 'No',
}

export default {
  name: 'verification-form-pep',
  components: {
    VerificationFormQuestion,
  },
  mixins: [ FormMixin ],
  props: {
    former: {
      type: [VerificationCDDFormer, VerificationBDDFormer],
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    verificationDetails: {
      type: VerificationRecord,
      required: true,
    },
  },
  data () {
    return {
      form: {
        qus01: this.former.attrs.pep.qus01,
        qus02: this.former.attrs.pep.qus02,
        pepInfo: this.former.attrs.pep.pepInfo,
        countryRisk: this.former.attrs.pep.countryRisk,
      },
      isAllSet: false,
      CB_VALUES,
    }
  },
  computed: {
    watchlistReportLink () {
      let applicantId = this.verificationDetails.data.kyc.id
      return `https://cockpit.sumsub.com/checkus#/applicant/${applicantId}/basicInfo?clientId=swarm`
    },
  },
  watch: {
    form: {
      handler (obj) {
        this.isAllSet = Object.values(obj).every(value => {
          return value && value !== 'Yes'
        })
      },
      deep: true,
      immediate: true,
    },
  },
  validations () {
    let form = {
      qus01: { required },
      qus02: { required },
    }

    if (this.form.qus01 === CB_VALUES.yes) {
      form.pepInfo = { required }
    }
    if (this.form.qus02 === CB_VALUES.yes) {
      form.countryRisk = { required }
    }

    return { form }
  },
}
</script>
